<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-1>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >
                  <v-layout shrink ma-0 pa-1 >
                    <v-flex xs4 >
                      <v-select
                        :data-testid="$options.name + '__select__' + 'dhcpServer'"
                        v-model="model.obj.dhcpServer"
                        light
                        auto-grow
                        :items="getItems.server"
                        :label="$t('DHCP server')"
                        outline
                        hide-details
                        return-object
                        class="white"
                        background-color="primary"
                        rows="1"
                        height="56.48"
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(item) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(item) }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>

                  <v-layout shrink ma-0 pa-1 >
                    <v-flex xs4 >
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'startIP'"
                        v-model="model.obj.startIP"
                        light
                        auto-grow
                        outline
                        flat
                        :label="$t('start IP-address')"
                        hint
                        class="white"
                        background-color="primary"
                        hide-details
                        rows="1"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout shrink ma-0 pa-1 >
                    <v-flex xs4 >
                      <v-text-field
                        :data-testid="$options.name + '__text-field__' + 'endIP'"
                        v-model="model.obj.endIP"
                        light
                        auto-grow
                        outline
                        flat
                        :label="$t('end IP-address')"
                        hint
                        class="white"
                        background-color="primary"
                        hide-details
                        rows="1"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  
                  <v-layout column fill-height pa-1>
                    <scroll-table
                      :data="getTable"
                      :options="getOptions"
                      @select="(payload) => onRowClick(payload)"
                      @value=""
                    />
                  </v-layout>

                  <v-checkbox small light color="primary" v-model="model.obj.onlyNew" :data-testid="$options.name + '__checkbox__' + 'onlyNew'">
                    <template v-slot:label>
                      <span class="black--text" >{{$t('only new devices')}}</span>
                    </template>
                  </v-checkbox>

                  <v-layout v-if="show" column fill-height  pt-1>
                    <v-layout fill-height pa-0>
                      <v-flex xs4>
                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'addDevice.vendor'"
                              v-model="model.addDevice.vendor"
                              light
                              auto-grow
                              outline
                              readonly
                              flat
                              :label="$t('vendor')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'addDevice.template'"
                              v-model="model.addDevice.template"
                              light
                              auto-grow
                              outline
                              readonly
                              flat
                              :label="$t('template')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'addDevice.user'"
                              v-model="model.addDevice.user"
                              light
                              auto-grow
                              outline
                              :readonly="!!model.addDevice.template"
                              :disabled="!!model.addDevice.template"
                              flat
                              :label="$t('user')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink ma-0 py-1 >
                          <v-flex xs12 >
                            <v-text-field
                              :data-testid="$options.name + '__text-field__' + 'addDevice.password'"
                              v-model="model.addDevice.password"
                              light
                              auto-grow
                              outline
                              :readonly="!!model.addDevice.template"
                              :disabled="!!model.addDevice.template"
                              flat
                              :label="$t('password')"
                              hint
                              class="white"
                              background-color="primary"
                              hide-details
                              rows="1"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>

                        <v-layout shrink justify-end ma-0 py-1 >
                          <v-flex shrink >
                            <v-layout ma-0 pa-0>
                              <v-layout ma-0 pa-0 justify-end>
                                <v-tooltip dark color="secondary" bottom>
                                  <v-btn small color="primary" slot="activator" light text 
                                  :data-testid="$options.name + '__btn__' + 'save'"
                                  @click="">{{$t('save changes')}}</v-btn>
                                  <span>{{ $t('save changes') }}</span>
                                </v-tooltip>
                              </v-layout>
                            </v-layout>
                          </v-flex>
                        </v-layout>

                      </v-flex>

                      <v-flex xs8 pl-1 pt-1>

                        <v-toolbar class="primary" flat dark dense>
                          <v-toolbar-title>
                            <span class="body-2 uppercase">{{ $t('disposition') }}</span>
                          </v-toolbar-title>
                        </v-toolbar>

                        <v-flex grow style="height: 80%">
                          <scroll-area>
                            <template slot="body">
                              <v-treeview
                                :active.sync="model.addDevice.treeActive"
                                :open.sync="model.addDevice.treeOpen"
                                :items="$store.state.structure.manage.tree"
                                active-class="grey lighten-4 indigo--text"
                                selected-color="indigo"
                                open-on-click
                                selectable
                                expand-icon="mdi-chevron-down"
                                on-icon="check_box"
                                off-icon="check_box_outline_blank"
                                indeterminate-icon="indeterminate_check_box"
                              >
                                <template v-slot:label="{ item, open }">
                                  <span class="caption font-weight-medium font-condensend">{{
                                    item.name
                                  }}</span>
                                </template>
                              </v-treeview>
                            </template>
                          </scroll-area>
                        </v-flex>                    
                        
                      </v-flex>
                    </v-layout>
                  </v-layout>

                </v-layout>

              </template>

            </scroll-area>

          </v-layout>
        </v-flex>
        
      </v-layout>

    </v-layout>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'

// Типы
interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableRow {
  status: string
  vendor: string
  mac: string
  ip: string
  template: string
  name?: string
  [key: string]: any
}

interface TableData {
  columns: TableColumn[]
  rows: TableRow[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ItemsData {
  server: string[]
}

interface AddDeviceData {
  vendor: string | null
  template: string | null
  user: string | null
  password: string | null
  disposition: string | null
  treeActive: any[]
  treeOpen: any[]
}

interface ModelData {
  obj: {
    transmit_interval: number | null
    transmit_hold_multiplier: number | null
    reinitialization_delay: number | null
    notification_interval: number | null
  }
  addDevice: AddDeviceData
}

interface DeviceData {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'DHCP_CONFIGURATION',

  components: {
    scrollArea,
    scrollTable
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
  },

  data(): {
    show: boolean
    items: ItemsData
    model: ModelData
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      show: false,
      items: {
        server: ['enabled', 'disabled'],
      },
      model: {
        obj: {
          transmit_interval: null,
          transmit_hold_multiplier: null,
          reinitialization_delay: null,
          notification_interval: null,
        },
        addDevice: {
          vendor: null,
          template: null,
          user: null,
          password: null,
          disposition: null,
          treeActive: [],
          treeOpen: [],
        }
      },
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'status',
            value: 'status',
            type: 'text',
            width: '20%'
          },
          {
            title: 'vendor',
            value: 'vendor',
            type: 'text',
            width: '20%'
          },
          {
            title: 'MAC address',
            value: 'mac',
            type: 'text',
            width: '20%'
          },
          {
            title: 'IP address',
            value: 'ip',
            type: 'text',
            width: '20%'
          },
          {
            title: 'template',
            value: 'template',
            type: 'text',
            width: '20%'
          }
        ],
        rows: [
          {
            status: 'ok',
            vendor: 'FPlus',
            mac: 'EE:EE:EE:EE:EE:EE',
            ip: '10.10.10.10',
            template: '2328',
          }
        ]
      },
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },

    getItems(): ItemsData {
      return this.items
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData

      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.vendor?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.mac?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.ip?.toLowerCase().indexOf(searchLower) > -1 ||
                 row.template?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getOptions(): OptionsData {
      return this.options
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    setup(): void {
      // Метод предназначен для переопределения при необходимости
    },

    onRowClick(val: TableRow): void {
      console.log(this.$options.name, 'onRowClick', val)
      this.show = !this.show

      if (val && this.show) {
        this.$set(this.model.addDevice, 'vendor', val.vendor)
        this.$set(this.model.addDevice, 'template', val.template)
      }

      if (!this.show) {
        this.$set(this.model.addDevice, 'vendor', null)
        this.$set(this.model.addDevice, 'template', null)
        this.$set(this.model.addDevice, 'user', null)
        this.$set(this.model.addDevice, 'password', null)
        this.$set(this.model.addDevice, 'disposition', null)
        this.$set(this.model.addDevice, 'treeActive', [])
        this.$set(this.model.addDevice, 'treeOpen', [])
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
